import React from 'react'
import PropTypes from 'prop-types'
import css from './MetricBox.module.scss'
import FlexContainer from '../FlexContainer/FlexContainer.jsx'
import Label from '../Label/Label.jsx'

const MetricBox = ({
  title,
  icon,
  className,
  style,
  bgColor, 
  fontColor,
  variant,
  value,
  percentageValue,
}) => {
  const variantClass = variant ? css[variant] : '';
  const customStyles = !variant ? {backgroundColor: bgColor, color: fontColor} : {};
  const mergedStyles = {...customStyles, ...style};
  
  return (
    <FlexContainer
      className={`${css.metricBox} ${variantClass} ${className ? className : ''}`}
      style={mergedStyles}
      gap={30}
      justifyContent="space-between"
      flex={1}
    >
      <FlexContainer className={css.metricBoxTitle} gap={5} alignItems="center">
        {icon && <span className={css.metricBoxIcon}>{icon}</span>}
        <span>{title}</span>
      </FlexContainer>
      <FlexContainer className={css.metricBoxValue} gap={5}>
        {percentageValue && percentageValue !== 0 ?
          <Label variant={variant === 'danger' ? 'danger' : 'success'}>
            {percentageValue}%
          </Label>
        : ''}
        {value}
      </FlexContainer>
    </FlexContainer>
  )
}

MetricBox.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'danger']),
  percentageValue: PropTypes.number,
}

export default MetricBox;
